<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		
		<el-page-header @back="goBack" :content="from.name">
		</el-page-header>
		<!-- 表格 -->
		<div class="mt-3 " style="padding-bottom:20px">
			 <el-tabs v-model="activeName" >
			    <el-tab-pane :label="$t('cdnd.nav1')" name="1">
					<el-card class="box-card">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('cdnd.info')}}</span>
					
						  </div>
					  <el-descriptions  :column="2">
					      <el-descriptions-item :label="$t('cdn.domain')">{{from.name}}</el-descriptions-item>
					      <el-descriptions-item :label="$t('status.status')">
							  <span style="color: #999;" v-if="info.status==2">{{$t('cdn.status2')}}</span>
							  <span class="text-success" v-if="info.status==1">{{$t('cdn.status1')}}</span>
							  <span class="text-danger" v-if="info.status==0">{{$t('cdn.status0')}}</span>
						  </el-descriptions-item>
					      <el-descriptions-item :label="$t('cdn.cname')">
							  <div v-if="info.get_status==0 || info.get_status==1">
							  	<span style="color: #999;">{{$t('cdn.status2')}}</span>
							  	<span @click="checkCnameDetail(info)" class="pl-1" style="color: #000;font-size: 18px;cursor: pointer;"><i :class="info.load==0?'el-icon-refresh':'el-icon-loading'"></i></span>
							  </div>
							  
							  <div v-else >
							  	<span class="mb-4">{{ info.cname }}</span>
							  	<span class="iconCopy" @click="copyText(info.cname)"><i class="iconfont icon-fuzhi"></i></span>
							  </div>
						  </el-descriptions-item>
					      <el-descriptions-item :label="$t('cdn.business_type')">
								<span v-if="info.business_type==1">{{$t('cdn.business_type1')}}</span>
								<span v-if="info.business_type==2">{{$t('cdn.business_type2')}}</span>
								<span v-if="info.business_type==3">{{$t('cdn.business_type3')}}</span>
								<span v-if="info.business_type==4">{{$t('cdn.business_type4')}}</span>
					      </el-descriptions-item>
					      <el-descriptions-item :label="$t('cdnd.https')">
							  <span v-if="info.ssl_status==1">{{$t('cdnd.open')}}</span>
							  <span v-if="info.ssl_status==0">{{$t('cdnd.close')}}</span>
						  </el-descriptions-item>
						  <el-descriptions-item :label="$t('cdn.product')">
							  <span>{{info.pro_name}}</span>
						  </el-descriptions-item>
						  
						  <el-descriptions-item :label="$t('cdn.remark')">
						  		<span>{{info.remark}}</span>
						  </el-descriptions-item> 
						  <el-descriptions-item :label="$t('adminList.createTime')">
						  		<span>{{info.create_time}}</span>
						  </el-descriptions-item>
					  </el-descriptions>
					</el-card>
					
					
					<el-card class="box-card mt-3">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('cdn.source')}}</span>
							<el-button @click="openSourceModel(info)" style="float: right; padding: 3px 0" type="text">{{$t('cdn.update')}}</el-button>
						  </div>
					  
					   <el-table
					        :data="info.source"
					        style="width: 100%">
					        <el-table-column align="center" prop="source" :label="$t('cdn.source')">
					        </el-table-column>
							<el-table-column align="center" prop="port" :label="$t('cdn.port')">
					        </el-table-column>
					        <el-table-column align="center" prop="type" :label="$t('cdn.source_type')">
								<template slot-scope="scope">
									<span  v-if="scope.row.type==1">{{$t('cdn.source_type1')}}</span>
									<span  v-if="scope.row.type==2">{{$t('cdn.source_type2')}}</span>
								</template>
					        </el-table-column>
					        <!-- <el-table-column align="center"  :label="$t('adminList.operation')">
								<template slot-scope="scope">
									<el-button-group>
										
										<el-button size="mini" plain type="success" v-auth="'editAdmin'" @click="openModel(scope.row)">{{$t('cdnd.edit')}}</el-button>
										
									
										
										<el-button   size="mini" plain type="danger" v-auth="'editAdmin'" @click="deleteSource(scope.row)">{{$t('cdn.del')}}</el-button>
										
										
									</el-button-group>
								</template>
					        </el-table-column> -->
					      </el-table>
					</el-card>
					
				</el-tab-pane>
			    <!-- <el-tab-pane :label="$t('cdnd.nav2')" name="2">
					<el-card class="box-card mt-3">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('cdnd.range')}}</span>
							
						  </div>
						<div>
							<div>{{$t('cdnd.range1')}}</div>
							<div class="text_chengse mb-2 mt-2">{{$t('cdnd.range2')}}</div>
							<el-switch
							@change="changeRnage"
							  v-model="rangeStatus"
							  active-color="#13ce66"
							  inactive-color="#999999">
							</el-switch>
						</div>
					   
					</el-card>
				</el-tab-pane> -->
			    <el-tab-pane :label="$t('cdnd.nav3')" name="3">
					<el-card class="box-card mt-3">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('cdnd.nav3')}}</span>
							
						  </div>
						<div>
							<!-- <div class="mb-3">{{$t('cdnd.info1')}}</div> -->
							
							<el-button  class="mb-2" size="small" v-if="layout.user.type==1" @click="openCertModel(info.cert_find)" v-auth="'update'+auth_val" >{{$t('cdnd.edit')}}</el-button>
							 <el-descriptions
								:column="1"
								:label-style="{ width: '120px', color: '#666' }"
								:content-style="{ color: '#333' }"
								>
								<el-descriptions-item :label="$t('cdn.ssl_status')">
									<span class="text-danger" v-if="info.cert_find.status==3">{{$t('cdn.ssl_status2')}}</span>
									<span class="text-success" v-if="info.cert_find.status==1">{{$t('cdn.ssl_status1')}}</span>
									<span class="text-danger" v-if="info.cert_find.status==0">{{$t('cdn.ssl_status2')}}</span>
									<span class="text-danger" v-if="info.cert_find.status==2">{{$t('cdn.ssl_status2')}}</span>
								</el-descriptions-item>

								<el-descriptions-item :label="$t('cdn.end_time')">{{info.cert_find.end_time}}</el-descriptions-item>
								<el-descriptions-item :label="$t('cdn.valid_time')">{{info.cert_find.diffMonths}}{{$t('cdn.valid_time_str')}}</el-descriptions-item>
								<el-descriptions-item :label="$t('cdn.issuerString')">{{info.cert_find.issuerString}}</el-descriptions-item>
								<el-descriptions-item :label="$t('cdn.domain')">{{from.name}}</el-descriptions-item>
							</el-descriptions>
							
							<!-- <el-table
							     :data="info.cert"
							     style="width: 100%">
									<el-table-column align="center" prop="name" :label="$t('cdnd.cert_name')">
									</el-table-column>
								 
							     <el-table-column align="center" prop="type" :label="$t('cdnd.cert_from')">
								<template slot-scope="scope">
									<span  v-if="scope.row.type==1">{{$t('cdnd.cert_from1')}}</span>
									<span  v-if="scope.row.type==2">{{$t('cdnd.cert_from2')}}</span>
									
								</template>
									</el-table-column>
									<el-table-column align="center" prop="end_time" :label="$t('cdnd.end')">
									</el-table-column>
							   </el-table> -->
						</div>
					   
					</el-card>
					
					
					<el-card class="box-card mt-3">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('cdnd.info2')}}</span>
						  </div>
						<div>
							<div class="mb-3">{{$t('cdnd.info3')}}</div>
							
							<span class="mr-2">{{$t('cdnd.info4')}}</span>
							<el-switch
							@change="changeSSL"
							:active-value="1"
  							:inactive-value="0"
							  v-model="https_status"
							  active-color="#13ce66"
							  inactive-color="#999999">
							</el-switch>
						</div>
					   
					</el-card>

					<el-card class="box-card mt-3">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('cdnd.info7')}}</span>
							
						  </div>
						<div>
							<div class="mb-3">{{$t('cdnd.info6')}}</div>
							
							<span class="mr-2">{{$t('cdnd.info8')}}</span>
							<el-switch
								@change="changeSSL3"
								:active-value="1"
  								:inactive-value="0"
								v-model="http3_status"
								active-color="#13ce66"
								inactive-color="#999999">
							</el-switch>
						</div>
					   
					</el-card>
				</el-tab-pane>
			    <el-tab-pane :label="$t('cdnd.nav4')" name="4">
					<el-card class="box-card mt-3">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('cdnd.cache_end_time')}}</span>
							<el-button @click="openCacheModel(false)" style="float: right; padding: 3px 0" type="text">{{$t('cdnd.add')}}</el-button>
						  </div>
					  
					   <el-table
					        :data="info.cache_info"
					        style="width: 100%">
					        <el-table-column align="center" prop="type" :label="$t('cdnd.cache_type')">
					        </el-table-column>
							<el-table-column align="center" prop="content" :label="$t('cdnd.cache_content')">
					        </el-table-column>
							<el-table-column align="center" prop="time" :label="$t('cdnd.cache_time')">
					        </el-table-column>
							  <el-table-column align="center" prop="status" :label="$t('cdnd.cache_status')">
								<template slot-scope="scope">
									<span class="text-success" v-if="scope.row.status==1">{{$t('cdnd.cache_status1')}}</span>
									<span class="text-danger" v-if="scope.row.status==2">{{$t('cdnd.cache_status2')}}</span>
								</template>
					        </el-table-column>
							<el-table-column align="center" prop="wage" :label="$t('cdnd.cache_wage')">
					        </el-table-column>
					      
					        <el-table-column align="center"  :label="$t('adminList.operation')">
								<template slot-scope="scope">
									<el-button-group>
										
										<el-button size="mini" plain type="success" v-auth="'editAdmin'" @click="openCacheModel(scope.row)">{{$t('cdnd.edit')}}</el-button>
										<el-button size="mini" plain type="danger" v-auth="'editAdmin'" @click="deleteCache(scope.row)">{{$t('cdn.del')}}</el-button>
										
									</el-button-group>
								</template>
					        </el-table-column> 
					      </el-table>
					</el-card>
				</el-tab-pane>
			    <el-tab-pane :label="$t('cdnd.nav5')" name="5">

					<el-card class="box-card mt-3">
						 <div slot="header" class="clearfix">
						    <span class="body_head">{{$t('cdnd.nav5')}}</span>
							
						  </div>
						<div>
							<div class="mb-3">{{$t('cdnd.info5')}}</div>
							
							<el-descriptions  :column="2">
								<el-descriptions-item :label="$t('cdnd.group')">{{group_info ? group_info.name : $t('cdnd.noGroup')}}</el-descriptions-item>
							</el-descriptions>
							<el-button size="mini" plain type="success" v-auth="'editAdmin'" @click="openModel(scope.row)">{{$t('cdnd.edit')}}</el-button>
						</div>
					   
					</el-card>

				</el-tab-pane>
			  </el-tabs>
		</div>


		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('cdnd.editCert') : $t('cdnd.editCert')"
			:visible.sync="createCertModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rulesCert" ref="certForm" :model="certForm" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item :label="$t('cdnd.certName')" prop="name">
					<el-input  @input="handleSourceInput"  v-model="certForm.name" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('cdnd.cert_crt')" prop="cert_crt">
					<el-input  @input="handleSourceInput"  v-model="certForm.cert_crt" type="textarea" :rows="8"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				<el-form-item :label="$t('cdnd.cert_key')" prop="cert_key">
					<el-input  @input="handleSourceInput"  v-model="certForm.cert_key"  type="textarea" :rows="8"  clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>

				<el-form-item :label="$t('cdnd.certStatus')">
						<el-radio-group  v-model="certForm.status" size="small">
							<el-radio :label="1" border>{{$t('cdnd.certStatus1')}}</el-radio>
							<el-radio :label="2" border>{{$t('cdnd.certStatus2')}}</el-radio>
						</el-radio-group>
				</el-form-item>
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createCertModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitCert">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>


		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('cdnd.editSource') : $t('cdnd.addSource')"
			:visible.sync="createSourceModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="Sourcerules" ref="Sourceform" :model="Sourceform" :label-width="layout.is_phone?'80px':'100px'">
				
				<el-form-item :label="$t('source.domain_name')" prop="domain_name">
					<el-input  v-model="Sourceform.domain_name"  disabled :placeholder="$t('source.domain_name')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>

				<el-form-item :label="$t('source.type')">
					<el-radio-group  v-model="Sourceform.type" size="small">
						<el-radio :label="1" border>{{$t('cdnd.source_type.1')}}</el-radio>
						<el-radio :label="2" border>{{$t('cdnd.source_type.2')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				<el-form-item v-if="Sourceform.type == 2" :label="$t('cdn.sourceList')" class="mb-0">
					<el-select v-model="Sourceform.source_id" size="small" filterable :placeholder="$t('system.select')" >
						<el-option v-for="item in agentData.sourceList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				<el-form-item v-if="Sourceform.type == 1" :label="$t('source.sourceList')" prop="sourceList">
					<el-button @click="addSource(false)" style="margin-bottom: 10px;">{{ $t('source.addSource') }}</el-button>
								<el-table :data="Sourceform.sourceList" border style="width: 100%" @selection-change="handleSelectionChange">
									
									<el-table-column align="center" prop="type" :label="$t('source.type')">
										<template slot-scope="v">
											<el-tag v-if="v.row.type==1" >{{$t('source.type1')}}</el-tag>
											<el-tag v-if="v.row.type==2" >{{$t('source.type2')}}</el-tag>
										</template>
									</el-table-column>
									
									<el-table-column align="center" prop="source" :label="$t('source.source')"></el-table-column>
									<el-table-column align="center" prop="port" :label="$t('source.port')"></el-table-column>
									<el-table-column align="center" prop="weight" :label="$t('source.weight')"></el-table-column>
									
									<el-table-column align="center" prop="priority" :label="$t('source.priority')">
										<template slot-scope="v">
											<el-tag v-if="v.row.priority==1" >{{$t('source.priority1')}}</el-tag>
											<el-tag v-if="v.row.priority==2" >{{$t('source.priority2')}}</el-tag>
										</template>
									</el-table-column>

									<!-- <el-table-column align="center" prop="priority" :label="$t('source.priority')"></el-table-column> -->

									<el-table-column prop="id" align="center" width="140" :label="$t('layout.operation')">
										<template slot-scope="scope">
											<el-button-group>
												<el-button size="mini" plain type="primary" @click="addSource(scope)">{{ $t('layout.operation') }}</el-button>
												<el-button @click="delSource(scope)" :disabled="scope.row.is_default ? true : false" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button>
											</el-button-group>
										</template>
									</el-table-column>
								</el-table>
				</el-form-item>

				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createSourceModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitSource">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>


		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('cdnd.editSource') : $t('cdnd.addSource')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 修改域名回源地址 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
				<el-form-item :label="$t('source.name')" prop="name">
					<el-input  v-model="form.name"  :placeholder="$t('source.name')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
				</el-form-item>


				<el-form-item :label="$t('cdn.source')" prop="url">
					<el-input  @input="handleSourceInput"  v-model="form.url" :type="editIndex > -1?'text':'textarea'" :rows="8"  :placeholder="form.source_type==1?$t('cdn.source_tis_1'):$t('cdn.source_tis_2')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

		<el-dialog :close-on-click-modal="false"
			:title="$t('cdnd.editSource')"
			:visible.sync="createGroupModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" ref="formGroup" :model="formGroup" :label-width="layout.is_phone?'80px':'100px'">
				<el-form-item :label="$t('cdn.source')" prop="url">
					<el-select   v-model="formGroup.id" size="small" filterable :placeholder="$t('system.select')">
						<el-option v-for="item in agentData.group" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>


			
		<el-dialog :close-on-click-modal="false"   :title="editSourceInfoIndex > -1 ? $t('source.editSource') : $t('source.addSource')" :append-to-body="true" :visible.sync="createSourceInfoModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
			<div style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form :rules="rulesSource" ref="formSource" :model="formSource" :label-width="layout.is_phone?'80px':'100px'">
							
					<el-form-item :label="$t('source.type')">
						<el-radio-group  v-model="formSource.type" size="small">
							<el-radio :label="1" border>{{$t('source.type1')}}</el-radio>
							<el-radio :label="2" border>{{$t('source.type2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
				
					<el-form-item :label="$t('source.source')" prop="source">
						<el-input v-model="formSource.source" :placeholder="$t('source.source')" clearable size="small" style="width: 85%;" ></el-input>
					</el-form-item>

					<el-form-item :label="$t('source.port')" prop="port">
						<el-input v-model="formSource.port" type="number" :placeholder="$t('source.port')" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>

					<el-form-item :label="$t('source.weight')" prop="weight">
						<el-input v-model="formSource.weight" type="number" :placeholder="$t('source.weight')" clearable size="small" style="width: 85%;"></el-input>
					</el-form-item>
					
								
					<el-form-item :label="$t('source.priority')">
						<el-radio-group  v-model="formSource.priority" size="small">
							<el-radio :label="1" border>{{$t('source.priority1')}}</el-radio>
							<el-radio :label="2" border>{{$t('source.priority2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
<!-- 				
					<el-form-item :label="$t('source.priority')" prop="priority">
						<el-input v-model="formSource.priority" type="number" :placeholder="$t('source.priority')" clearable size="small" style="width: 85%;" auto-complete="new-password"></el-input>
					</el-form-item> -->
					
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createSourceInfoModel = false">{{$t('system.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitSourceInfo">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>



			
		<el-dialog :close-on-click-modal="false"   :title="editCacheInfoIndex > -1 ? $t('cdnd.edit_cache') : $t('cdnd.add_cache')" :append-to-body="true" :visible.sync="createCacheModel" top="5vh" :width="layout.is_phone?'90%':'80%'">
			<div style="max-height: 65vh; overflow: auto;">
				<!-- 表單内容 -->
				<el-form :rules="rulesCache" ref="cacheForm" :model="cacheForm" :label-width="layout.is_phone?'80px':'100px'">
						
					<el-form-item :label="$t('cdnd.cache_time')" prop="time">
						<el-input v-model="cacheForm.time" type="number" :placeholder="$t('cdnd.cache_time')" clearable size="small" style="width: 85%;" ></el-input>
						<div style="font-size: 12px; color: #909399;">{{$t('cdnd.cache_time_info')}}</div>
					</el-form-item>

					
					<el-form-item :label="$t('cdnd.time_type')">
						<el-select v-model="cacheForm.time_type">
							<el-option :label="$t('cdnd.time_type1')" :value="1"></el-option>
							<el-option :label="$t('cdnd.time_type2')" :value="2"></el-option>
							<el-option :label="$t('cdnd.time_type3')" :value="3"></el-option>
							<el-option :label="$t('cdnd.time_type4')" :value="4"></el-option>
						</el-select>
					</el-form-item>

								
					<el-form-item :label="$t('cdnd.cache_type')">
						<el-radio-group  v-model="cacheForm.type" size="small">
							<el-radio :label="2" border>{{$t('cdnd.cache_type1')}}</el-radio>
							<el-radio :label="1" border>{{$t('cdnd.cache_type2')}}</el-radio>
						</el-radio-group>
					</el-form-item>
					
					<el-form-item v-if="cacheForm.type == 2" :label="$t('cdnd.cache_type1')" prop="content">
						<el-input v-model="cacheForm.content"  type="textarea" :rows="8" clearable size="small" style="width: 85%;"></el-input>
						<div style="font-size: 12px; color: #909399;">{{$t('cdnd.cache_type1_info')}}</div>
					</el-form-item>

					<el-form-item v-if="cacheForm.type == 1" :label="$t('cdnd.cache_type2')" prop="content">
						<el-input v-model="cacheForm.content"  type="textarea" :rows="8" clearable size="small" style="width: 85%;"></el-input>
						<div style="font-size: 12px; color: #909399;">{{$t('cdnd.cache_type2_info')}}</div>
					</el-form-item>

					<el-form-item :label="$t('source.weight')" prop="wage">
						<el-input v-model="cacheForm.wage" type="number" :placeholder="$t('source.weight')" clearable size="small" style="width: 85%;"></el-input>
						<div style="font-size: 12px; color: #909399;">{{$t('cdnd.weight_info')}}</div>
					</el-form-item>

					
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="createCacheModel = false">{{$t('system.cancel')}}</el-button>
				<el-button :loading="layout.loading" :disabled="layout.loading" type="primary" @click="submitCacheInfo">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>


	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				activeName:"1",
				createModel: false,
				createGroupModel: false,
				createCertModel: false,
				createSourceModel: false,
				createSourceInfoModel: false,
				createCacheModel: false,
				editIndex: -1,
				editSourceInfoIndex: -1,
				editCacheInfoIndex: -1,
				info:{},
				rangeStatus:0,
				ssl_status:0,
				http3_status:0,
				https_status:0,
				group_info:{},
				certForm:{},
				cacheForm:{},
				Sourceform:{
					sourceList:[],
				},
				formSource:{
					source:'',
					id:0,
					type:1,
					port:80,
					weight:1,
					priority:1,
				},
				//搜索數据
				from: {
					id:0,
					name: '',
					username:'',
					sup_id:-1,
					status:-1,
					get_status:-1,
					type:-1,
					cloud_id:-1,
					time:[],
				},
				formGroup: {
					id:0,
				},
				Sourcerules:{},
				
				auth_val: 'Admin',
				odds:0,
				preUrl: "data/domainDetail", //列表地址
				delAllUrl: "data/delAccountAll", //批量删除地址
				delUrl: "data/addSource", //删除單条地址
				addUrl: "data/addSource", //添加/修改地址
				editStatusUrl:"data/editStatusAccount",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {},
				rules: {
					url: [{
						required: true,
						message: this.$t('cdn.inpSource'),
						trigger: 'blur'
					}],
				},
				rulesCert: {
					name: [{
						required: true,
						message: this.$t('cdnd.inpCertName'),
						trigger: 'blur'
					}],
					cert_crt: [{
						required: true,
						message: this.$t('cdnd.inpCertCar'),
						trigger: 'blur'
					}],
					cert_key: [{
						required: true,
						message: this.$t('cdnd.inpCertKey'),
						trigger: 'blur'
					}],
				},
				rulesSource: {
					source: [
						{
							required: true,
							message: this.$t('source.sourceRequired'),
							trigger: 'blur'
						},
						{
							validator: (rule, value, callback) => {
								if (!value) {
									return callback();
								}

								const domainRegex = /^(?!:\/\/)([a-zA-Z0-9-_]+\.)+[a-zA-Z]{2,}$/;
								const ipRegex = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}$/;

								if (domainRegex.test(value) || ipRegex.test(value)) {
									callback();
								} else {
									callback(new Error('请输入有效的域名或IP地址'));
								}
							},
							trigger: 'blur'
						}
					],
					port: [{
						required: true,
						message: this.$t('userList.portRequired'),
						trigger: 'blur',
					}],
					weight: [{
						required: true,
						message: this.$t('userList.weightRequired'),
						trigger: 'blur',
					}],
					priority: [{
						required: true,
						message: this.$t('userList.priorityRequired'),
						trigger: 'blur',
					}],
				},
				rulesCache: {
					content: [{
						required: true,
						message: this.$t('cdnd.contentRequired'),
						trigger: 'blur',
					}],
					time: [{
						required: true,
						message: this.$t('cdnd.cacheTimeRequired'),
						trigger: 'blur',
					}],
					wage: [
						{
						required: true,
						message: this.$t('cdnd.priorityRequired'),
						trigger: 'blur',
						},
						{
						validator: (rule, value, callback) => {
							const n = parseInt(value)
							if (isNaN(n)) {
							callback(new Error(this.$t('cdnd.priorityRequired')))
							} else if (n < 1 || n > 99) {
							callback(new Error(this.$t('cdnd.priorityRange')))
							} else {
							callback()
							}
						},
						trigger: 'blur'
						}
					]
				},
				rule_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList(['group','sourceList']);
			
			if(localStorage.getItem('domainDetail')){
				let domainDetail = JSON.parse(localStorage.getItem('domainDetail'));
				this.from.name = domainDetail.domain_name
				this.from.id = domainDetail.id
				// this.search = this.from
			}else{
				this.goBack()
			}
		},
		methods: {
			openCacheModel(e){
				if (!e) {
					// 修改
					this.cacheForm = {
						id: -1,
						content: '',
						type: 2,
						time: '',
						status: '',
						wage: '',
						time_type: 1,
						cid: this.info.id,
					}
					// 初始化表單
					this.editCacheInfoIndex = -1
				} else {
					// 修改
					this.cacheForm = {
						id: e.id,
						content: e.content,
						type: e.type,
						time:e.time,
						status:e.status,
						wage:e.wage,
						time_type:e.time_type,
						cid: this.info.id,
					}
					this.editCacheInfoIndex = e.$index
				}
			
				// 打开dialog
				this.createCacheModel = true
			},

			submitCacheInfo(){
				this.$refs.cacheForm.validate(valid => {
					if (valid) {
						this.layout.loading = true;
							this.axios.post('/admin/data/updateCacheDetail', this.cacheForm , {
								token: true,
							}).then(res => {
								this.layout.loading = false;
								this.createCacheModel = false;
								this.getList();
							}).catch(err => {
								// 失敗
								this.layout.loading = false;
							})
					}
				});
			},
			submitSourceInfo(){
				this.$refs.formSource.validate(valid => {
					if (valid) {
						if (this.editSourceInfoIndex === -1) {
							// 添加新題目
							this.Sourceform.sourceList.push(this.formSource);
						} else {
							// 修改现有題目
							this.$set(this.Sourceform.sourceList, this.editSourceInfoIndex, {...this.formSource});
						}
						
						// 重置表單和關閉模态框
						this.resetSourceForm();
					}
				});
			},
			delSource(scope){
				// 獲取要刪除的名次 ID 或索引
				const index = scope.$index; // 行的索引
				this.Sourceform.sourceList.splice(index, 1); // 刪除對應行
			},
			resetSourceForm(){
				this.formSource = {
					source:'',
					id:0,
					type:1,
					port:80,
					weight:1,
					priority:1,
				}
				this.editSourceInfoIndex = -1;
				this.createSourceInfoModel = false;
			},
			goBack(){
				localStorage.setItem('domainDetail', '');
				this.$router.push({
					name: 'cdn_domain',
					params:{}
				})
			},
			//添加修改源站列表
			addSource(e = false){
				if (!e) {
					// 初始化表單
					this.editSourceInfoIndex = -1
				} else {
					// 修改
					this.formSource = {
						source: e.row.source,
						id: e.row.id,
						type: e.row.type,
						port: e.row.port,
						weight:e.row.weight,
						priority:e.row.priority,
					}
					this.editSourceInfoIndex = e.$index
				}
			
				// 打开dialog
				this.createSourceInfoModel = true
			},
			handleSourceInput(val) {
				let num = 50 - parseInt(this.info.count)
				console.log(num)
			    const lines = val.split('\n');
			    if (lines.length > num) {
			      this.form.url = lines.slice(0, num).join('\n'); // 只保留前 50 行
			      this.$message.warning(this.$t('cdn.limitSource'));
			    }
			  },
			  changeRnage(e){
				  let val = this.rangeStatus?1:0
				  this.editDomain('range_status',val)
			  },
			  changeSSL(e){
				  let val = this.https_status?1:0
				  this.editDomain('https_status',val)
			  },
			  changeSSL3(e){
				  let val = this.http3_status?1:0
				  this.editDomain('http3_status',val)
			  },
			  editDomain(type,val){
				  this.layout.loading = true;
				  this.axios.post('/admin/data/editDomain', {
				  	type: type,
				  	val: val,
				  	id:this.info.id
				  }, {
				  	token: true,
				  }).then(res => {
				  	let all = res.data
				  	let list = all.data.list
					
				  	
				  	this.layout.loading = false;
				  }).catch(err => {
				  	// 失敗
					if(type=='range_status'){
						this.rangeStatus = this.rangeStatus==1?0:1
					}
					
					if(type=='https_status'){
						this.https_status = this.https_status==1?0:1
					}
					if(type=='http3_status'){
						this.http3_status = this.http3_status==1?0:1
					}
					
					
				  	this.layout.loading = false;
				  })
				  //console.log(this.rangeStatus)
			  },
			getMainAccount(e){
				this.commonList('account1',e);
			},
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 1
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			changeMoneyType(e){
				if(e==1){
					this.form.money = 0
				}
				//console.log(e)
			},
			
			deleteSource(item) {
				let index = this.info.source.findIndex(item=>item.url == item.url)
				this.$confirm(this.$t('system.yesOrNoDel'), this.$t('system.prompt'), {
					confirmButtonText: this.$t('system.delete'),
					cancelButtonText: this.$t('system.cancel'),
					type: 'warning'
				}).then(() => {
					this.layout.loading = true;
					this.axios.post(this.deleteUrl(), {
						cid: this.info.id,
						index:index,
						type:3
					}, {
						token: true
					}).then(res => {
						let all = res.data;
						if (all.code == 1) {
							this.$message({
								message: this.$t('system.deleteSuccess'),
								type: 'success'
							});
							this.getList()
						}
						
						this.layout.loading = false;
					}).catch(err => {
						this.layout.loading = false;
					})
				})
			},
			deleteCache(item){
				
			},
			submitSource(){
				this.$refs.Sourceform.validate(res => {
					this.layout.loading = true;
					this.axios.post('/admin/data/checkSourceDetail', this.Sourceform , {
						token: true,
					}).then(res => {
						this.layout.loading = false;
						this.createSourceModel = false;
						this.getList();
					}).catch(err => {
						// 失敗
						this.layout.loading = false;
					})
				})
			},
			submitCert(){
				this.$refs.certForm.validate(res => {
					this.layout.loading = true;
					this.axios.post('/admin/data/updateCertDetail', this.certForm , {
						token: true,
					}).then(res => {
						this.layout.loading = false;
						this.createCertModel = false;
						this.getList();
					}).catch(err => {
						// 失敗
						this.layout.loading = false;
					})
				})
			},

			//提交
			submit() {
				// if (this.form.password != this.form.password2) {
				// 	this.$message({
				// 		message: this.$t('adminList.differentPasswords'),
				// 		type: 'error'
				// 	});
				// 	return
				// }
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},
			
			checkCnameDetail(item) {
				console.log(item)
				if(item.load==1){
					return false;
				}
				item.load = 1;
				this.axios.post('/admin/data/checkCnameDetail', {
					id:item.id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					
					console.log(list)
					
					item.get_status = list.get_status
					item.status = list.status
					item.cname = list.cname
					
					item.load = 0;
				}).catch(err => {
					// 失敗
					item.load = 0;
				})
			},

			// 打开模态框
			openSourceModel(e = false) {
				// 增加
				// console.log(e)
				
					// let index = this.info.source.findIndex(item=>item.url == e.url)
					//console.log(index)
					// 修改
					this.Sourceform = {
						domain_name:e.domain_name,
						id:e.id,
						source_id:e.source_id,
						type:e.source_id == 0 ? 1 : 2,
						sourceList:e.sourceList,
					}
					this.editIndex = this.info.id
			
				
				// 打开dialog
				this.createSourceModel = true
			},

			// 打开模态框
			openCertModel(e = false) {
				this.certForm = {
						name:e.name,
						cert_crt:e.cert_crt,
						cert_key:e.cert_key,
						status:e.status,
						id:e.id,
					}
				
					this.editIndex = e.id
				
				this.createCertModel = true
			},

			// 打开模态框
			openGroupModel() {
				this.formGroup = {
					id:this.group_info.id,
					name:this.group_info.name
				}
				// 打开dialog
				this.createGroupModel = true
			},

			//公共列表
			commonList(type,id=0) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.agentData = list
					
					this.layout.loading = false;
				}).catch(err => {
					
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.info = e.info
				this.group_info = e.group_info
				this.rangeStatus = this.info.range_status
				this.ssl_status = this.info.ssl_status
				this.http3_status = parseInt(this.info.cert_find.http3_status)
				this.https_status =  parseInt(this.info.cert_find.https_status)
				
				
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					get_status:-1,
					type:-1,
					cloud_id:-1,
					time:[],
				}
				
				// this.$refs.buttonSearch.closeSuperSearch()

				
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style >
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}

.el-descriptions-item__container {
    display: flex;
    align-items: flex-end;
	height: 30px;
}

.body_head{
	font-weight: bold;
	font-size: 15px;
}
</style>
